import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Input,
  Dropdown,
  Label,
  Button,
  Icon
} from 'semantic-ui-react'

const CardSupplyOrderWorkflowUX = (props: any) => {
    return(
      <div
        id="CardSupplyOrderWorkflow"
        style={{padding: "10px",width: "100%"}}>
        <div
          id="CardSupplyOrderWorkflowUX-div-1"
          style={{display: "none", justifyContent: "flex-start", alignItems: "center",padding: "10px 0px 20px 0px"}}>
          
          <div
            id="CardSupplyOrderWorkflowUX-div-9"
            style={{fontWeight: "bold" , fontSize: "large", marginRight: "10px"}}>
            {props.languageUX === "en" ? "Enter code" : "กรอกรหัส"}
          </div>
          <Input
            id="CardSupplyOrderWorkflowUX-Input-30"
            onChange={props.changeCoUser}
            onKeyDown={(e: any) => { e.key === "Enter" && props.coUserVerify(); }}
            style={{marginRight: "10px"}}
            value={props.coUser}>
          </Input>
          <Dropdown
            id="CardSupplyOrderWorkflowUX-Dropdown-31"
            selection={true}>
          </Dropdown>
        </div>
        <div
          id="CardSupplyOrderWorkflowUX-div-2"
          style={{display: "flex", justifyContent: "space-between", margin: "10px 0px 10px 0px"}}>
          
          <div
            id="CardSupplyOrderWorkflowUX-div-12"
            style={{display: "flex", alignItems:"center"}}>
            
            <Label
              color={props.ribbonColor}
              id="CardSupplyOrderWorkflowUX-Label-33"
              style={{marginRight: "10px", display: props.titleRibbon?"":"none"}}>
              {props.titleRibbon}
            </Label>
            <div
              id="CardSupplyOrderWorkflowUX-div-34"
              style={{fontWeight: "bold",fontSize: "large"}}>
              {props.title}
            </div>
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-13"
            style={{display: "flex", alignItems:"center"}}>
            
            <Label
              color={props.statusColor}
              id="CardSupplyOrderWorkflowUX-Label-35"
              style={{marginRight: "10px", display: props.status?"":"none"}}>
              {props.statusName}
            </Label>
            <Label
              color={props.isPaidColor}
              id="CardSupplyOrderWorkflowUX-Label-36"
              style={!props.isPaid ? {display: "none"} : {}}>
              {props.isPaid}
            </Label>
          </div>
        </div>
        <div
          id="CardSupplyOrderWorkflowUX-div-67">
          {props.userActionLogList}
        </div>
        <Table
          data={props.supplyData}
          getTrProps={props.getTrProps}
          headers={props.headers ? props.headers : "No,Code,Mode,Product Name,ขนาดบรรจุ,คงคลัง,จำนวนสั่ง,จะจ่าย,คืน,หน่วยสั่ง,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,ส่วนลด,Eligibility Type"}
          id="CardSupplyOrderWorkflowUX-Table-20"
          keys={props.keys ? props.keys : "no,code,mode,nameStatus,package_size,stock_balance,quantity_request, quantity_issue,returned_quantity, stock_unit, price_unit, price_total, price_claimable, price_non_claimable, price_discount, eligibility_type"}
          minRows={10}
          showPagination={false}
          widths={props.widths ? props.widths : "^40,^100,^105,^180,^100,^60,^60,^90,^60,^90,^100,^70,^60,^70,^60,^120"}>
        </Table>
        <div
          id="CardSupplyOrderWorkflowUX-div-86"
          style={{margin:"10px"}}>
          {props.errorMessage}
        </div>
        <div
          id="CardSupplyOrderWorkflowUX-div-21"
          style={{display: "flex",margin:"10px 0px", width: "100%"}}>
          
          <div
            id="CardSupplyOrderWorkflowUX-div-22"
            style={{display: "flex",justifyContent:"center",alignItems:"center",gap:"10px",margin: "0px 10px", width: "25%"}}>
            
            <div
              id="CardSupplyOrderWorkflowUX-div-55"
              style={{minWidth: "max-content"}}>
              {props.isCostCenter ? "มูลค่ารวม" : "ราคารวม"}
            </div>
            <Input
              fluid={true}
              id="CardSupplyOrderWorkflowUX-Input-59"
              style={{width: "100%"}}
              value={props.sumPriceTotal}>
            </Input>
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-23"
            style={{display: props.isCostCenter? "none": "flex",justifyContent:"center",alignItems:"center",gap:"10px",margin: "0px 10px", width: "25%"}}>
            
            <div
              id="CardSupplyOrderWorkflowUX-div-56"
              style={{minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Claimable" : "เบิกได้"}
            </div>
            <Input
              fluid={true}
              id="CardSupplyOrderWorkflowUX-Input-60"
              style={{width: "100%"}}
              value={props.sumPriceClaimable}>
            </Input>
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-24"
            style={{display: props.isCostCenter? "none": "flex",justifyContent:"center",alignItems:"center",gap:"10px",margin: "0px 10px", width: "25%"}}>
            
            <div
              id="CardSupplyOrderWorkflowUX-div-57"
              style={{minWidth: "max-content"}}>
              {props.languageUX === "en" ? "Non Claimable" : "เบิกไม่ได้"}
            </div>
            <Input
              fluid={true}
              id="CardSupplyOrderWorkflowUX-Input-61"
              style={{width: "100%"}}
              value={props.sumPriceNonClaimable}>
            </Input>
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-25"
            style={{display: props.isCostCenter? "none": "flex",justifyContent:"center",alignItems:"center",gap:"10px",margin: "0px 10px", width: "25%"}}>
            
            <div
              id="CardSupplyOrderWorkflowUX-div-58"
              style={{minWidth: "max-content"}}>
              {props.languageUX === "en" ? "discount" : "ส่วนลด"}
            </div>
            <Input
              fluid={true}
              id="CardSupplyOrderWorkflowUX-Input-62"
              style={{width: "100%"}}
              value={props.sumPriceDiscount}>
            </Input>
          </div>
        </div>
        <div
          id="CardSupplyOrderWorkflowUX-div-26"
          style={{display: "flex",margin: "10px 10px"}}>
          
          <div
            id="CardSupplyOrderWorkflowUX-div-68"
            style={{display:"flex"}}>
            
            <Button
              icon={true}
              id="CardSupplyOrderWorkflowUX-Button-65"
              onClick={props.refreshSupply}
              size="small">
              <Icon
                id="CardSupplyOrderWorkflowUX-Icon-66"
                name={"redo"}>
              </Icon>
            </Button>
            <Button
              icon={true}
              id="CardSupplyOrderWorkflowUX-Button-64"
              onClick={props.getActionLog}
              size="small">
              {props.languageUX === "en" ? "LOG" : "บันทึก"}
            </Button>
            <div
              id="CardSupplyOrderWorkflowUX-div-85"
              style={{display:props.status ==="PRINTED" ? "":"none"}}>
              {props.buttonRePrint}
            </div>
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-82"
            style={{flex:"1"}}>
            
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-81">
            {props.additionalProps}
          </div>
          <div
            id="CardSupplyOrderWorkflowUX-div-69"
            style={{display: "flex", gap: "5px", alignItems: "center",marginLeft:"10px"}}>
            
            <Button
              color="yellow"
              id="CardSupplyOrderWorkflowUX-Button-70"
              onClick={props.onEdit}
              size="small"
              style={{display: props.status === "REQUESTED" || props.status === "VERIFY" ? "" : "none"}}>
              {props.languageUX === "en" ? "correct" : "แก้ไข"}
            </Button>
            <Button
              disabled={props.selectedRow ? false : true}
              id="CardSupplyOrderWorkflowUX-Button-78"
              onClick={props.returnSupply}
              size="small"
              style={{display: props.showButtonReturn? "" : "none"}}>
              {props.languageUX === "en" ? "Return medical supplies" : "คืนเวชภัณฑ์"}
            </Button>
            <div
              id="btn-supplyCheckOrder"
              style={{display: props.status === "REQUESTED" || props.status === "VERIFY" ? "" : "none"}}>
              {props.buttonCheckOrder}
            </div>
            <div
              id="btn-supplyCheck"
              style={{display: props.status === "PRINTED" ? "" : "none"}}>
              {props.buttonCheck}
            </div>
            <div
              id="CardSupplyOrderWorkflowUX-div-74"
              style={{display: props.checkIPD || props.checkOPD ? "" : "none"}}>
              {props.buttonPaid}
            </div>
            <div
              id="CardSupplyOrderWorkflowUX-div-83"
              style={{ ...((!props.showButtonReceived) && {display: "none"}) }}>
              {props.buttonReceive}
            </div>
            <Button
              id="CardSupplyOrderWorkflowUX-Button-77"
              onClick={props.OnReturn}
              size="small"
              style={{display: props.showButtonRequestReturn ? "":"none"}}>
              {props.languageUX === "en" ? "Request for return of medical supplies" : "ขอคืนเวชภัณฑ์"}
            </Button>
            <Button
              color="red"
              id="CardSupplyOrderWorkflowUX-Button-72"
              onClick={props.OnCancel}
              size="small"
              style={{display: props.status === "REQUESTED" || props.status === "VERIFY" ? "" : "none"}}>
              {props.languageUX === "en" ? "Cancel order" : "ยกเลิกการสั่ง"}
            </Button>
            <Button
              color="red"
              id="CardSupplyOrderWorkflowUX-Button-75"
              onClick={props.OnUnCheck}
              size="small"
              style={{display:props.unCheck || props.unCheckOneday ? "" : "none"}}>
              {props.languageUX === "en" ? "Cancellation of arrangement" : "ยกเลิกการจัด"}
            </Button>
            <Button
              color="red"
              id="CardSupplyOrderWorkflowUX-Button-76"
              onClick={props.OnUndeliver}
              size="small"
              style={{ ...( props.hideBtnUnDeliver  && { display: "none" })}}>
              {props.languageUX === "en" ? "Cancel payment" : "ยกเลิกการจ่าย"}
            </Button>
            <Button
              color="red"
              id="CardSupplyOrderWorkflowUX-Button-84"
              onClick={props.OnUnVerify}
              size="small"
              style={{display: props.status === "PRINTED"  || props.status === "VERIFIED"? "" : "none"}}>
              {props.languageUX === "en" ? "Cancel inspection" : "ยกเลิกการตรวจ"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardSupplyOrderWorkflowUX

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:29:53 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflow"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\",width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\", justifyContent: \"flex-start\", alignItems: \"center\",padding: \"10px 0px 20px 0px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", margin: \"10px 0px 10px 0px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "กรอกรหัส",
          "valueEN": "Enter code"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\" , fontSize: \"large\", marginRight: \"10px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems:\"center\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems:\"center\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 20,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.supplyData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.headers ? props.headers : \"No,Code,Mode,Product Name,ขนาดบรรจุ,คงคลัง,จำนวนสั่ง,จะจ่าย,คืน,หน่วยสั่ง,ราคาต่อหน่วย,ราคารวม,เบิกได้,เบิกไม่ได้,ส่วนลด,Eligibility Type\""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Table-20"
        },
        "keys": {
          "type": "code",
          "value": "props.keys ? props.keys : \"no,code,mode,nameStatus,package_size,stock_balance,quantity_request, quantity_issue,returned_quantity, stock_unit, price_unit, price_total, price_claimable, price_non_claimable, price_discount, eligibility_type\""
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": "props.widths ? props.widths : \"^40,^100,^105,^180,^100,^60,^60,^90,^60,^90,^100,^70,^60,^70,^60,^120\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",margin:\"10px 0px\", width: \"100%\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",justifyContent:\"center\",alignItems:\"center\",gap:\"10px\",margin: \"0px 10px\", width: \"25%\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isCostCenter? \"none\": \"flex\",justifyContent:\"center\",alignItems:\"center\",gap:\"10px\",margin: \"0px 10px\", width: \"25%\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isCostCenter? \"none\": \"flex\",justifyContent:\"center\",alignItems:\"center\",gap:\"10px\",margin: \"0px 10px\", width: \"25%\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isCostCenter? \"none\": \"flex\",justifyContent:\"center\",alignItems:\"center\",gap:\"10px\",margin: \"0px 10px\", width: \"25%\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",margin: \"10px 10px\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Input-30"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoUser"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => { e.key === \"Enter\" && props.coUserVerify(); }"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.coUser"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Dropdown",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Dropdown-31"
        },
        "selection": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Label",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleRibbon"
        },
        "color": {
          "type": "code",
          "value": "props.ribbonColor"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Label-33"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", display: props.titleRibbon?\"\":\"none\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",fontSize: \"large\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Label",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusName"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Label-35"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", display: props.status?\"\":\"none\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Label",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.isPaid"
        },
        "color": {
          "type": "code",
          "value": "props.isPaidColor"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Label-36"
        },
        "style": {
          "type": "code",
          "value": "!props.isPaid ? {display: \"none\"} : {}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.isCostCenter ? \"มูลค่ารวม\" : \"ราคารวม\""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกได้",
          "valueEN": "Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "discount"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Input",
      "parent": 22,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Input-59"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.sumPriceTotal"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 23,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Input-60"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.sumPriceClaimable"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Input",
      "parent": 24,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Input-61"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.sumPriceNonClaimable"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 25,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Input-62"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.sumPriceDiscount"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Button",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "LOG"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-64"
        },
        "onClick": {
          "type": "code",
          "value": "props.getActionLog"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Button",
      "parent": 68,
      "props": {
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-65"
        },
        "onClick": {
          "type": "code",
          "value": "props.refreshSupply"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Icon",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Icon-66"
        },
        "name": {
          "type": "code",
          "value": "\"redo\""
        },
        "onClick": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.userActionLogList"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-67"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", gap: \"5px\", alignItems: \"center\",marginLeft:\"10px\"}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไข",
          "valueEN": "correct"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-70"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEdit"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status === \"REQUESTED\" || props.status === \"VERIFY\" ? \"\" : \"none\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการสั่ง",
          "valueEN": "Cancel order"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-72"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnCancel"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status === \"REQUESTED\" || props.status === \"VERIFY\" ? \"\" : \"none\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCheck"
        },
        "id": {
          "type": "value",
          "value": "btn-supplyCheck"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status === \"PRINTED\" ? \"\" : \"none\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPaid"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{display: props.checkIPD || props.checkOPD ? \"\" : \"none\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการจัด",
          "valueEN": "Cancellation of arrangement"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-75"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnUnCheck"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display:props.unCheck || props.unCheckOneday ? \"\" : \"none\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการจ่าย",
          "valueEN": "Cancel payment"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-76"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnUndeliver"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ ...( props.hideBtnUnDeliver  && { display: \"none\" })}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ขอคืนเวชภัณฑ์",
          "valueEN": "Request for return of medical supplies"
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-77"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnReturn"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showButtonRequestReturn ? \"\":\"none\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "คืนเวชภัณฑ์",
          "valueEN": "Return medical supplies"
        },
        "disabled": {
          "type": "code",
          "value": "props.selectedRow ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-78"
        },
        "onClick": {
          "type": "code",
          "value": "props.returnSupply"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showButtonReturn? \"\" : \"none\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCheckOrder"
        },
        "id": {
          "type": "value",
          "value": "btn-supplyCheckOrder"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status === \"REQUESTED\" || props.status === \"VERIFY\" ? \"\" : \"none\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.additionalProps"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-81"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonReceive"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ ...((!props.showButtonReceived) && {display: \"none\"}) }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Button",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการตรวจ",
          "valueEN": "Cancel inspection"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-Button-84"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnUnVerify"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.status === \"PRINTED\"  || props.status === \"VERIFIED\"? \"\" : \"none\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRePrint"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{display:props.status ===\"PRINTED\" ? \"\":\"none\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardSupplyOrderWorkflowUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 26,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSupplyOrderWorkflowUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
